import { useState, useEffect } from "react";
import { Box, Button, TextField, Autocomplete } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeComments } from "./UseHomeComments";

export default function CategoryInformation(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { validate, GetHomeComments, addComment, updateComment } =
    UseHomeComments();
  const headerColors = ["بدون رنگ", "primary", "secondary"];

  const [state, setState] = useState({
    id: 0,
    aid: location.state.commentId ? location.state.commentId : 0,
    title: undefined,
    headerColorName: null,
    moreTitle: undefined,
    moreURL: undefined,
  });

  useEffect(() => {
    if (location.state.commentId) {
      setState({
        aid: location.state.commentId,
        id: 0,
        title: "",
      });
      setProgress(true);
      GetHomeComments(location.state.commentId, (callback) => {
        setState({
          aid: callback.aid == 0 ? location.state.commentId : callback.aid,
          id: callback.id,
          title: callback.title,
          headerColorName: callback.headerColorName,
          moreTitle: callback.moreTitle,
          moreURL: callback.moreURL,
        });
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/CommentsManage",
            commentId: location.state.commentId,
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn="span 4">
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            error={errorState.title}
            label="عنوان"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 8"></Box>
        <Box gridColumn="span 4">
          <TextField
            fullWidth
            value={state.moreTitle ? state.moreTitle : ""}
            label="عنوان لینک"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, moreTitle: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 8"></Box>
        <Box gridColumn="span 6">
          <TextField
            fullWidth
            value={state.moreURL ? state.moreURL : ""}
            label="آدرس لینک"
            sx={{
              textarea: {
                direction: "rtl",
              },
            }}
            multiline
            rows={2}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, moreURL: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 6"></Box>
        <Box gridColumn="span 3">
          <Autocomplete
            size="small"
            value={state.headerColorName ? state.headerColorName : ""}
            onChange={(event, newValue) => {
              if (newValue == "بدون رنگ") {
                setState({
                  ...state,
                  headerColorName: null,
                });
              } else if (newValue) {
                setState({
                  ...state,
                  headerColorName: newValue,
                });
              } else {
                setState({
                  ...state,
                  headerColorName: null,
                });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            sx={{ width: "80%" }}
            getOptionLabel={(option) => option}
            fullWidth
            options={headerColors}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="رنگ هدر" />
            )}
          />
        </Box>
        <Box gridColumn="span 9"></Box>
        <Box
          gridColumn="span 4"
          sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                if (state.id == 0) {
                  addComment(state, () => {
                    GetHomeComments(state.aid, (callback) => {
                      setState({
                        aid: callback.aid,
                        id: callback.id,
                        title: callback.title,
                        headerColorName: callback.headerColorName,
                        moreTitle: callback.moreTitle,
                        moreURL: callback.moreURL,
                      });
                    });
                  });
                } else {
                  updateComment(state, () => {
                    GetHomeComments(state.aid, (callback) => {
                      setState({
                        aid: callback.aid,
                        id: callback.id,
                        title: callback.title,
                        headerColorName: callback.headerColorName,
                        moreTitle: callback.moreTitle,
                        moreURL: callback.moreURL,
                      });
                    });
                  });
                }
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
